import toast from "react-hot-toast";
import axiosInstance from "../../../axiosInstance";

export const getAllFeaturedOffers = (setOffers) => {
  axiosInstance
    .get("/home/all-offers")
    .then((res) => {
      setOffers(res.data.offers);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};

export const getOffer = (setOffers, id) => {
  axiosInstance
    .get(`/home/get-offer/${id}`)
    .then((res) => {
      setOffers(res.data.data);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
export const OffersForAll = (setOffers, setIsLoading) => {
  setIsLoading(true);
  axiosInstance
    .get("/home/offers-for-all")
    .then((res) => {
      setTimeout(() => {
        setOffers(res.data.offers);
        setIsLoading(false);
      }, 2000);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
export const geAllFeaturedHotels = (setData, setIsLoading) => {
  setIsLoading(true);
  axiosInstance
    .get("/home/get-featured-hotels-full")
    .then((res) => {
      setTimeout(() => {
        setData(res.data.data);
        setIsLoading(false);
      }, 2000);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};

export const getBanners = (setData, setIsLoading) => {
  setIsLoading(true);
  axiosInstance
    .get("/home/get-banners")
    .then((res) => {
      setTimeout(() => {
        setData(res.data.data);
        setIsLoading(false);
      }, 2000);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
export const getAllFeaturedTours = (setData, setIsLoading) => {
  setIsLoading(true);
  axiosInstance
    .get("/home/get-featured-tours-full")
    .then((res) => {
      setTimeout(() => {
        setData(res.data.data);
        setIsLoading(false);
      }, 2000);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
